import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const KeralaPage = () => {
  return <DestinationTemplate destinationId="kerala" />;
};

export default KeralaPage;
